import React, { ReactNode } from "react";
import classnames from "classnames";

interface Props {
  as?: keyof JSX.IntrinsicElements;
  children: ReactNode | ReactNode[];
  className?: string;
  colorClass?: string;
  marginClass?: string;
}

export const Paragraph: React.FC<Props> = ({
  children,
  className,
  colorClass = "text-dark-gray",
  as: Tag = "p",
  marginClass = "my-4",
}: Props) => {
  return (
    <Tag className={classnames(marginClass, colorClass, className)}>
      {children}
    </Tag>
  );
};
